import { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';

const { defaultAlgorithm, darkAlgorithm } = antdTheme;

const theme: ThemeConfig = {
  algorithm: defaultAlgorithm,
  components: {
    Button: {
      colorPrimary: '#444B90',
    },
    Tabs: {
      inkBarColor: '#444B90', // Light Blue
    },
  },
  token: {
    colorPrimary: '#14162B', // Dark Blue
    colorPrimaryBg: '#444B90', // Light Blue
    colorTextSecondary: '#CFCFD3', // Light Grey

    colorBgLayout: '#FAFAFD', // Scratchpad color

    fontFamily: 'Satoshi, sans-serif',
  },
};

export const useTheme = () => {
  return antdTheme.useToken().token;
};

export default theme;
